<div [class.dark-theme]="true" class="fix-action-dialog">
	<h2 mat-dialog-title style="color:#fff;font-weight: 600;">{{content.title}}</h2>

	<mat-dialog-content fxLayout="column">
		<mat-card>
			<mat-card-content>
				<div>{{content.message}}</div>
			</mat-card-content>
		</mat-card>
	</mat-dialog-content>

	<div class="spacer"></div>

	<mat-dialog-actions fxLayout="row" fxLayoutAlign="space-around">
		<button (click)="cancel()" color="warn" mat-dialog-close="" mat-raised-button id="mat-cancel-button">{{content.cancel_button}}</button>
	</mat-dialog-actions>
</div>
